<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto">
      <div v-if="loader" class="flex flex-col justify-center items-center py-12">
        <svg class="animate-spin h-10 w-10 text-emerald-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-slate-500 font-medium">Carregando relatório...</span>
      </div>
      <All
        v-else
        id="conferenceList"
        :data="dataReport"
        :filter="filter"
        :prefecture="prefecture"
        :provider="provider"
        ref="allComponent"
      />
    </div>
  </div>
</template>

<script>
import All from "../impressions/conferencebillingsecretariart";
import helpers from "@/mixins/helpers";
export default {
  components: { All },
  props: {
    endDate: null,
    startDate: null,
    provider_id: null,
    prefecture_id: null,
    vehicle_id: null,
    sec_id: null,
  },
  mixins: [helpers],
  data: () => ({
    dataReport: [],
    filter: {},
    prefecture: [],
    provider: [],
    loader: false,
  }),
  created() {
    this.initialize();
    this.loadReport();
  },
  methods: {
    initialize() {
      this.helpers;
    },
    loadReport() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.filter.vehicle_id = this.vehicle_id;
      this.filter.provider_id = this.provider_id;
      this.filter.prefecture_id = this.prefecture_id;
      this.filter.startDate = this.startDate;
      this.filter.endDate = this.endDate;
      this.filter.sec_id = this.sec_id;
      this.$http
        .post(`/supplies/period/report/provider`, this.filter)
        .then((r) => {
          this.$http
            .get(`/prefectures/${this.filter.prefecture_id}`)
            .then((p) => {
              this.prefecture = p.data[0];
              this.$http
                .get(`/providers/${this.filter.provider_id}`)
                .then((pp) => {
                  this.provider = pp.data[0];
                  this.dataReport = r.data;
                  this.showPrintPageOne = true;

                  let resume = [];
                  let totalFinalLiters = 0;
                  let totalFinalValuesBilling = 0;

                  if (r.data && r.data.supplies) {
                    r.data.supplies.forEach((element) => {
                      totalFinalLiters += Number(element.totalLiters || 0);
                      totalFinalValuesBilling += Number(element.totalValue || 0);

                      const index = resume.findIndex(
                        (v) => v.item_id == element.item_id
                      );
                      if (index >= 0) {
                        resume[index].totalLiters += Number(element.totalLiters || 0);
                        resume[index].totalValue += Number(element.totalValue || 0);
                      } else {
                        resume.push({
                          item_id: element.item_id,
                          item_description_desc: element.item_description_desc,
                          supply_bidding_price: element.supply_bidding_price,
                          totalLiters: Number(element.totalLiters || 0),
                          totalValue: Number(element.totalValue || 0),
                        });
                      }
                    });
                  }

                  if (!this.dataReport.finalTotals) {
                    this.dataReport.finalTotals = {};
                  }
                  this.dataReport.finalTotals.totalFinalLiters = totalFinalLiters;
                  this.dataReport.finalTotals.totalFinalValuesBilling = totalFinalValuesBilling;
                  this.dataReport.resume = resume;

                  // this.$refs.allComponent.initialize();
                  setTimeout(() => {
                    this.loader = false;
                    this.$store.dispatch("setLoader", this.loader);
                  }, 1000);
                })
                .catch((e) => {
                  this.loader = false;
                  this.$store.dispatch("setLoader", false);
                  console.error(e);
                });
            })
            .catch((e) => {
              this.loader = false;
              this.$store.dispatch("setLoader", false);
              console.error(e);
            });
        })
        .catch((e) => {
          this.loader = false;
          this.$store.dispatch("setLoader", false);
          alert("Erro ao carregar relatório: " + (e.message || e));
        });
    },
  },
};
</script>

<style></style>
